import { EnumColor } from '@40seas/frontend/common/providers';
import { RutterCompanyConnectionStatus, RutterCompany } from '@40seas/entities/rutter';

export const rutterCompanyConnectionStatusMapping = {
    [RutterCompanyConnectionStatus.Pending]: 'default',
    [RutterCompanyConnectionStatus.Active]: 'success',
    [RutterCompanyConnectionStatus.Inactive]: 'error',
} as { [key in RutterCompanyConnectionStatus]: EnumColor };
